module.exports = __webpack_public_path__ + "img/FDCentral.369b4361.jpg";